import angular from 'angular';
import uiRouter from 'angular-ui-router';
import CreditorComponent from './creditor.component';

let CreditorModule = angular
  .module('Creditor', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newCreditor', {
        url: '/creditors/new',
        component: 'creditor',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editCreditor', {
        url: '/creditors/:id',
        component: 'creditor',
        parent: 'main',
        data: {
          permissions: {
            only: ['ADMIN'],
            redirectTo: 'home'
          }
        },
        resolve: {
          creditor: (CreditorsService, $stateParams) => {
            return CreditorsService.findById($stateParams.id);
          }
        }
      });
  })
  .component('creditor', CreditorComponent).name;

export default CreditorModule;
